import React from "react";
import s from "./MobileHeader.module.scss";
import { Link } from "react-router-dom";
import {
  CaretDownFilled,
  GlobalOutlined,
  LogoutOutlined,
  PullRequestOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import type { MenuProps } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { setLang } from "../../redux/ApplicationSlice";

const MobileLoginHeader = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const lang = useSelector((state: RootState) => state.application.lang);
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const changeLang = (lang: "en" | "ru" | "ge") => {
    i18n.changeLanguage(lang);
  };

  const options4 = (
    <Menu>
      <Menu.Item key='1'>
        <div
          onClick={() => {
            dispatch(setLang("ge"));
            changeLang("ge");
          }}
          className={s.menu_lang_item}
        >
          <img src='/georgia.png' className={s.flag} /> GE
        </div>
      </Menu.Item>
      <Menu.Item key='2'>
        <div
          onClick={() => {
            dispatch(setLang("en"));
            changeLang("en");
          }}
          className={s.menu_lang_item}
        >
          <img src='/united-states.png' className={s.flag} />
          EN
        </div>
      </Menu.Item>
      <Menu.Item key='3'>
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
          className={s.menu_lang_item}
        >
          <img src='/russia (1).png' className={s.flag} />
          RU
        </div>
      </Menu.Item>
    </Menu>
  );
  const items: MenuProps["items"] = [
    {
      key: "3",
      icon: <UserOutlined className={s.icon} />,
      label: <Link to='/payment_link'>{t("Оплатить заявку")}</Link>,
    },
    {
      key: "4",
      icon: <LogoutOutlined className={s.icon} />,
      label: <Link to='/login'>{t("Войти")}</Link>,
    },
  ];

  return (
    <div className={s.mobile_header}>
      <Link to='/home' className={s.logo}>
        <PullRequestOutlined style={{ marginRight: "5px" }} />
        Digital Transit Hub
      </Link>
      <div>
        {/* <Dropdown overlay={options4}>
          <div>
            <GlobalOutlined />
            &nbsp;&nbsp;
            {lang === "en" ? "EN" : lang === "ru" ? "RU" : "GE"} &nbsp;
            <CaretDownFilled />
          </div>
        </Dropdown> */}
      </div>

      {/* <Dropdown menu={{ items: items }}>
        <a onClick={(e) => e.preventDefault()}>
          <div className={s.menu}>
            <div className={s.menu_top}></div>
            <div className={s.menu_bottom}></div>
          </div>
        </a>
      </Dropdown> */}
    </div>
  );
};

export default MobileLoginHeader;
